import { Flex as AntdFlex } from 'antd';
import type { FlexProps } from 'antd/es';
import { observer } from '@formily/reactive-react';
import { useField } from '@formily/react';
import type { VoidField } from '@formily/core';

export interface IFlexProps extends FlexProps {}

const FormFlex = observer(({ children }: { children?: React.ReactNode }) => {
  const field = useField<VoidField>();
  const componentProps = (field?.componentProps || {}) as IFlexProps;

  return <AntdFlex {...componentProps}>{children}</AntdFlex>;
});

export default FormFlex;
